import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable()
export class YouTubeValidationService {
  youtubeRegex = '^(http(s)?:\\/\\/)?((w){3}.)?youtu(be|.be)?(\\.com)?\\/.+';
  embedSplitterRegex =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
  prefix = 'https://www.youtube.com/embed/';
  linkPostfix =
    '?&loop=1&showinfo=0&playsinline=1&fs=1&showinfo=0&disablekb=1&autoplay=0&rel=0';

  constructor(private sanitizer: DomSanitizer) {}

  public validateTransformAndSanitizeYouTubeLink(url: string): SafeResourceUrl {
    let validUrl = null;
    if (this.isValid(url)) {
      validUrl = url;
    } else {
      return null;
    }

    const embeddable = this.transformToEmbeddable(validUrl);

    if (embeddable) {
      return this.sanitize(embeddable);
    } else {
      return null;
    }
  }

  public isValid(linkToMatch: string): boolean {
    return !!(linkToMatch && linkToMatch.match(this.youtubeRegex));
  }

  public transformToEmbeddable(validUrl: string): string {
    const match = validUrl.match(this.embedSplitterRegex);
    let videoId = null;
    if (match && match[2].length === 11) {
      videoId = match[2];
    }

    if (videoId != null) {
      return this.prefix + videoId + this.linkPostfix;
    } else {
      return null;
    }
  }

  /**
   * only use after pattern validation
   * @param url
   */
  private sanitize(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
